var map = {
	"./1.jpg": 9849,
	"./10.jpg": 5605,
	"./11.jpg": 2088,
	"./12.jpg": 6839,
	"./13.jpg": 3002,
	"./2.jpg": 1182,
	"./3.jpg": 667,
	"./4.jpg": 7064,
	"./5.jpg": 8245,
	"./6.jpg": 4106,
	"./7.jpg": 9911,
	"./8.jpg": 2436,
	"./9.jpg": 6161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8541;